// extracted by mini-css-extract-plugin
module.exports = {"flop":"FlopGame_flop__A4giI"};